import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('studentdb');
import { FEATURES } from '@/access/features';

const studentdbRoutes = [
  {
    path: '/territory-info',
    name: 'territory-info-dashboard',
    meta: {
      showNav: true,
      feature: FEATURES.VMC_STUDENT_DB,
    },
    component: loadView('StudentsDashboard'),
  },
  {
    path: '/territory-info/schools/:schoolId',
    name: 'territory-info-school-detail',
    meta: {
      showNav: true,
      feature: FEATURES.VMC_STUDENT_DB,
    },
    props: true,
    component: loadView('StudentsSchoolDetail'),
  },
  {
    path: '/territory-info/map',
    name: 'territory-info-map',
    meta: {
      showNav: true,
      feature: FEATURES.VMC_STUDENT_DB,
    },
    component: loadView('StudentsMapView'),
  },
  {
    path: '/territory-info/:state',
    name: 'territory-info-state-detail',
    meta: {
      showNav: true,
      feature: FEATURES.VMC_STUDENT_DB,
    },
    props: true,
    component: loadView('StudentsStateDetail'),
  },
];

export default studentdbRoutes;
